import CryptoJS from 'crypto-js';

function md5(str: string): string {
  return CryptoJS.MD5(str).toString();
}

// 可通过环境变量设置盐值 VITE_PASSWORD_SALT，否则使用默认
// const DEFAULT_SALT = '';

export interface EncryptOptions {
  salt?: string; // 自定义盐
  double?: boolean; // 是否双重 md5（md5(password + salt) 再 md5 结果）
}

/**
 * 对密码进行 md5 + 盐 处理，默认: md5(password + SALT)
 * @param plain 原始明文密码
 * @param options 可选项：自定义盐、是否双重 md5
 */
export function encryptPassword(plain: string, options: EncryptOptions = {}): string {
  const salt = options.salt ?? import.meta.env.VITE_PASSWORD_SALT ?? '';
  const first = md5(plain + salt);
  if (options.double) {
    return md5(first + salt);
  }
  return first;
}
